import $ from 'jquery';
import {sendFilterEvent as sendLegacy} from "./legacy-analytics.js";
import {sendFilterEvent as sendAnalytics4} from "./google-analytics4.js";

function sendRangeFilterEvent($filter, value) {
    if ($filter.closest("[data-ae]").length > 0) {
        let label = $filter.closest("[data-ae]").data('ae');
        sendLegacy(label, value);
        sendAnalytics4(label, value);
    }
}

export function initRangeEvents(rangeWrapperId, rangeElementDOMName, currentMinValue, currentMaxValue) {
    $(document).on('change', rangeWrapperId + ' input', function () {
        let $elementMin = $('#' + rangeElementDOMName + 'Min');
        let valueMin = jsUtils.unMaskNumber($elementMin.val());
        let $elementMax = $('#' + rangeElementDOMName + 'Max');
        let valueMax = jsUtils.unMaskNumber($elementMax.val());

        if ((valueMin !== currentMinValue || valueMax !== currentMaxValue)) {
            if (valueMin !== currentMinValue) {
                sendRangeFilterEvent($elementMin, valueMin);
            }
            if (valueMax !== currentMaxValue) {
                sendRangeFilterEvent($elementMax, valueMax);
            }
            $("#param-" + rangeElementDOMName + "-min").val(valueMin);
            $("#param-" + rangeElementDOMName + "-max").val(valueMax);
            $("#searchLocationFilterForm").submit();
        }
    });

    $(document).on('click', rangeWrapperId + ' .dropdown-price', function(){
        let $element = $(this);
        let currentDropdown = $element.parents('.filter-dropdown');
        let where = currentDropdown.attr('data-where');
        let $elementMin = $("#" + rangeElementDOMName + "Min");
        let $elementMax = $("#" + rangeElementDOMName + "Max");
        if(where === rangeElementDOMName + '-min'){
            $elementMin.val( jsUtils.unMaskNumber($element.children().html()));
        }
        if(where === rangeElementDOMName + '-max') {
            $elementMax.val(jsUtils.unMaskNumber($element.children().html()));
        }

        if($elementMax.val()){
            if(Number($elementMin.val()) > Number($elementMax.val())) {
                $elementMin.val(null);
            }
        }
        currentDropdown.css('display', 'none');
        $element.closest("[data-ae]").find('input').trigger('change');
    });

    $(rangeWrapperId + ' .filter-dropdown').each(function(index, $dropdown){
        $($dropdown).closest("[data-ae]").find('input').on('focusin', function(e){
            e.stopPropagation();
            $($dropdown).show();
        })
    })
}